import axios, { getAuthHeaders, getFormDataHeaders } from "./config";

    export default {
    all: function() {
        return axios.get("/metadata", {
        headers: getAuthHeaders(),
        });
    },

    store: function(metadata) {
        return axios.post("/metadata", metadata, {
        headers: getFormDataHeaders(),
        });
    },
    show: function(metadataID) {
        return axios.get(`/metadata/${metadataID}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.put(`/metadata/${data.id}`, data, {
            headers: getAuthHeaders(),
        });
    },

    delete: function(metadataID) {
        return axios.delete(`/metadata/${metadataID}`, {
        headers: getAuthHeaders(),
        });
    },

    storeOption: function(data) {
        return axios.post(`/metadata/options`, data, {
            headers: getAuthHeaders(),
        })
    },

    allOptions: function () {
        return axios.get(`/options`, {
            headers: getAuthHeaders(),
        })
    }, 
    
    metadataOptions: function (metadataID) {
        return axios.get(`/metadata/${metadataID}/options`, {
            headers: getAuthHeaders(),
        })
    }
};
